import { cn } from '@/lib/utils';
import { Image as ImageIcon } from 'lucide-react';
import type { ImageGuidanceData } from './use-image-guidance';

// 与上传节点空状态菜单行（Connect image/video node）保持一致的样式
const MENU_ITEM_CN =
  'nodrag flex w-full items-center gap-4 px-4 py-3.5 text-sm font-medium text-foreground/80 whitespace-nowrap hover:bg-sidebar-accent/40 active:bg-sidebar-accent/60 transition-colors rounded-xl';

interface ImageGuidanceProps {
  guidance: ImageGuidanceData;
  onAddImageNode: () => void;
  t: (key: string) => string;
}

export function ImageGuidance({ guidance, onAddImageNode, t }: ImageGuidanceProps) {
  // 仅根据实际会渲染的按钮行（图片）判断，prompt 建议没有按钮，不计入
  const hasRows = Boolean(guidance.needsImage);

  // 如果没有需要显示的内容，不渲染
  if (!hasRows && !guidance.shouldShowCurrentMode) {
    return null;
  }

  return (
    <div className="w-full">
      {/* 根据模型能力显示快捷菜单行（样式与上传节点 Connect 菜单一致） */}
      {hasRows && (
        <div className="flex flex-col w-fit max-w-full mx-auto">
          <button type="button" className={MENU_ITEM_CN} onClick={onAddImageNode}>
            <ImageIcon size={18} className="text-muted-foreground/70 shrink-0" />
            <span className="shrink-0">{t('Add Image Upload Node')}</span>
            {guidance.imageProgress && (
              <span className="shrink-0 text-[10px] font-bold text-primary/60 tabular-nums">
                ({guidance.imageProgress.current}/{guidance.imageProgress.max})
              </span>
            )}
          </button>
        </div>
      )}

      {/* 当前模式 - 只有当有提示词输入时才显示，放在最底部 */}
      {guidance.shouldShowCurrentMode && (
        <div
          className={cn(
            "flex items-center justify-center gap-2",
            hasRows ? 'mt-3' : ''
          )}
        >
          <span className="text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground/30">{t('Current mode:')}</span>
          <span className="text-xs font-bold text-foreground/80 bg-sidebar-accent/50 px-2 py-0.5 rounded-lg border border-sidebar-border/30">{guidance.currentMode}</span>
        </div>
      )}
    </div>
  );
}

